<div class="chatbot-edit-modal p-8 bg-light-surface dark:bg-dark-surface flex flex-col max-h-[90vh] dark:[color-scheme:dark]">
  <!-- Header -->
  <div class="flex items-center gap-2 pb-2 pt-2">
    <h1 class="titulo">
      {{ isEditMode ? 'Editar Chatbot' : 'Agregar Chatbot' }}
    </h1>
  </div>

  <!-- Tabs -->
  <mat-tab-group class="flex-1 flex flex-col min-h-0 overflow-hidden">
    <!-- Tab: Datos Generales -->
    <mat-tab label="Datos Generales">
      <!-- Content with scroll -->
      <mat-dialog-content class="flex-1 overflow-y-auto h-full !px-0 !py-0">
        @if (chatbotForm) {
          <form [formGroup]="chatbotForm" class="space-y-0">
            <div class="flex flex-col md:flex-row gap-4 pt-4">
              <!-- Nombre -->
              <mat-form-field appearance="fill" class="w-full md:w-1/2">
                <mat-label>Nombre</mat-label>
                <input
                  matInput formControlName="name"
                  placeholder="Mi Chatbot"
                  [disabled]="saving"
                  class="text-light-text dark:text-dark-text">
                @if (chatbotForm.get('name')?.hasError('required')) {
                  <mat-error>
                    El nombre es requerido
                  </mat-error>
                }
              </mat-form-field>
              <!-- Descripción -->
              <mat-form-field appearance="fill" class="w-full md:w-1/2">
                <mat-label>Descripción</mat-label>
                <textarea matInput formControlName="description" placeholder="Descripción del chatbot" [disabled]="saving"
                cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="8" class="text-light-text dark:text-dark-text"></textarea>
                @if (chatbotForm.get('description')?.hasError('required')) {
                  <mat-error>
                    La descripción es requerida
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <!-- Si se está creando un chatbot -> se muestra el código acá -->
            @if (!isEditMode) {
              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Código</mat-label>
                <input matInput formControlName="code" placeholder="bot-001" [disabled]="saving"
                  class="text-light-text dark:text-dark-text">
                @if (chatbotForm.get('code')?.hasError('required')) {
                  <mat-error>
                    El código es requerido
                  </mat-error>
                }
                @if (chatbotForm.get('code')?.hasError('codeExists')) {
                  <mat-error>
                    Este código ya está registrado
                  </mat-error>
                }
                @if (chatbotForm.get('code')?.hasError('invalidCodeFormat')) {
                  <mat-error>
                    El código solo puede contener letras, números, guion bajo (_) y guion medio (-)
                  </mat-error>
                }
              </mat-form-field>
            }
            <!-- Endpoint -->
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>Endpoint chatbot</mat-label>
              <input matInput formControlName="endpointToSend" placeholder="https://api.ejemplo.com/send"
                class="text-light-text dark:text-dark-text" [disabled]="saving">
              @if (chatbotForm.get('endpointToSend')?.hasError('required')) {
                <mat-error>
                  El endpoint es requerido
                </mat-error>
              }
            </mat-form-field>
            <div class="flex flex-col md:flex-row gap-2">
              <!-- API Key / Credentials -->
              <mat-form-field appearance="fill" class="w-full md:w-1/2 pr-2">
                <mat-label>API Key</mat-label>
                <input matInput formControlName="credentials" type="password" placeholder="********"
                  class="text-light-text dark:text-dark-text" [disabled]="saving">
                @if (chatbotForm.get('credentials')?.hasError('required')) {
                  <mat-error>
                    La API Key es requerida
                  </mat-error>
                }
              </mat-form-field>
              <!-- Estado Activo -->
              <div class="flex-1 pt-2">
                <mat-checkbox formControlName="isActive" color="primary" [disabled]="saving">
                  <span class="text-light-text dark:text-dark-text font-medium">Chatbot activo</span>
                </mat-checkbox>
              </div>
            </div>
            <!-- Error global endpoint/credentials -->
            <div class="w-full">
              @if (chatbotForm.errors?.['endpointAndApiKey'] && (chatbotForm.get('endpointToSend')?.touched || chatbotForm.get('credentials')?.touched)) {
                <mat-error>
                  Debes completar ambos campos: Endpoint y API Key, o dejar ambos vacíos.
                </mat-error>
              }
            </div>
            @if (isEditMode && data.chatbot) {
              <div class="border-t border-light-border dark:border-dark-border my-2"></div>
            }
            <!-- Mostrar ID y Código modo edición -->
            @if (isEditMode && data.chatbot) {
              <div class="flex flex-col md:flex-row pt-2 gap-4">
                <!-- ID de Chatbot -->
                <div class="flex-1 p-2 flex items-center gap-2">
                  <span class="text-sm text-light-text-tertiary dark:text-dark-text-tertiary">ID de Chatbot:</span>
                  <span class="text-sm font-normal text-light-text dark:text-dark-text">{{ data.chatbot.chatbotId }}</span>
                </div>
                <!-- Si se está editando un chatbot -> se muestra el código acá -->
                <div class="flex-1 flex items-center p-2">
                  <div class="flex items-center gap-2 w-full">
                    <span class="text-sm text-light-text-tertiary dark:text-dark-text-tertiary">Código:</span>
                    <input matInput formControlName="code" placeholder="bot-001"
                      class="text-sm font-normal text-light-text dark:text-dark-text flex-1 border-none outline-none bg-transparent">
                  </div>
                </div>
              </div>
            }
            <!-- API Key -->
            @if (isEditMode && data.chatbot) {
              <div class="flex-1 p-2 pb-4 flex items-center gap-2">
                <span class="text-sm text-light-text-tertiary dark:text-dark-text-tertiary">Ruta de API Key:</span>
                @if (data.chatbot.credentials) {
                  <span class="text-sm font-normal text-light-text dark:text-dark-text">{{ data.chatbot.credentials }}</span>
                }
              </div>
            }
            <!-- Metadata -->
            @if (isEditMode && data.chatbot) {
              <div class="metadata-section pt-2 pb-2 pl-4 pr-4 rounded-xl space-y-3 border border-light-border dark:border-dark-border">
                <!-- Desktop Layout -->
                <div class="hidden md:block space-y-3">
                  <div class="flex justify-between items-center">
                    <span class="text-sm font-medium text-light-text-secondary dark:text-dark-text-secondary">Creado por:</span>
                    <span class="text-sm text-light-text dark:text-dark-text">{{ data.chatbot.createdBy || '-' }}</span>
                  </div>
                  <div class="flex justify-between items-center">
                    <span class="text-sm font-medium text-light-text-secondary dark:text-dark-text-secondary">Fecha de creación:</span>
                    <span class="text-sm text-light-text dark:text-dark-text">{{ formatDate(data.chatbot.createdAt) }}</span>
                  </div>
                  <div class="flex justify-between items-center">
                    <span class="text-sm font-medium text-light-text-secondary dark:text-dark-text-secondary">Última actualización:</span>
                    <span class="text-sm text-light-text dark:text-dark-text">{{ formatDate(data.chatbot.updatedAt) }}</span>
                  </div>
                  <div class="flex justify-between items-center">
                    <span class="text-sm font-medium text-light-text-secondary dark:text-dark-text-secondary">Actualizado por:</span>
                    <span class="text-sm text-light-text dark:text-dark-text">{{ data.chatbot.updatedBy || '-' }}</span>
                  </div>
                </div>
                <!-- Mobile Layout -->
                <div class="md:hidden space-y-4">
                  <div class="flex flex-col gap-1">
                    <span class="text-xs font-medium text-light-text-secondary dark:text-dark-text-secondary uppercase">Creado por</span>
                    <span class="text-sm text-light-text dark:text-dark-text">{{ data.chatbot.createdBy || '-' }}</span>
                  </div>
                  <div class="flex flex-col gap-1">
                    <span class="text-xs font-medium text-light-text-secondary dark:text-dark-text-secondary uppercase">Fecha de creación</span>
                    <span class="text-sm text-light-text dark:text-dark-text">{{ formatDate(data.chatbot.createdAt) }}</span>
                  </div>
                  <div class="flex flex-col gap-1">
                    <span class="text-xs font-medium text-light-text-secondary dark:text-dark-text-secondary uppercase">Última actualización</span>
                    <span class="text-sm text-light-text dark:text-dark-text">{{ formatDate(data.chatbot.updatedAt) }}</span>
                  </div>
                  <div class="flex flex-col gap-1">
                    <span class="text-xs font-medium text-light-text-secondary dark:text-dark-text-secondary uppercase">Actualizado por</span>
                    <span class="text-sm text-light-text dark:text-dark-text">{{ data.chatbot.updatedBy || '-' }}</span>
                  </div>
                </div>
              </div>
            }
          </form>
        }
      </mat-dialog-content>
    </mat-tab>

    <!-- Tab: Visualizador de Conversaciones -->
    <mat-tab label="Visualizador de Conversaciones">
      <mat-dialog-content class="flex-1 overflow-y-auto h-full !px-0 !py-0">
        @if (chatbotForm) {
          <form [formGroup]="chatbotForm" class="space-y-0">
            <!-- Endpoint -->
            <mat-form-field appearance="fill" class="w-full pt-6">
              <mat-label>Endpoint de conversaciones</mat-label>
              <input matInput formControlName="conversationVisualizerEndpoint" placeholder="https://api.ejemplo.com/send" [disabled]="saving"
                class="text-light-text dark:text-dark-text">
              @if (chatbotForm.get('conversationVisualizerEndpoint')?.hasError('required')) {
                <mat-error>
                  El endpoint es requerido
                </mat-error>
              }
            </mat-form-field>
            <div class="flex flex-col md:flex-row gap-2">
              <!-- API Key / Credentials -->
              <mat-form-field appearance="fill" class="w-full md:w-1/2 pr-2">
                <mat-label>API Key</mat-label>
                <input matInput formControlName="conversationVisualizerCredentials" type="password" placeholder="********"
                  class="text-light-text dark:text-dark-text" [disabled]="saving">
                @if (chatbotForm.get('conversationVisualizerCredentials')?.hasError('required')) {
                  <mat-error>
                    La API Key es requerida
                  </mat-error>
                }
              </mat-form-field>
              <!-- Estado Activo -->
              <div class="flex-1 pt-2">
                <mat-checkbox formControlName="isActive" color="primary" [disabled]="saving">
                  <span class="text-light-text dark:text-dark-text">Chatbot activo</span>
                </mat-checkbox>
              </div>
            </div>
            <!-- Error global conversation visualizer endpoint/credentials -->
            <div class="w-full">
              @if (chatbotForm.errors?.['conversationVisualizerIncomplete'] && (chatbotForm.get('conversationVisualizerEndpoint')?.touched || chatbotForm.get('conversationVisualizerCredentials')?.touched)) {
                <mat-error>
                  Debes completar ambos campos: Endpoint y API Key, o dejar ambos vacíos.
                </mat-error>
              }
            </div>
            <div class="border-t border-light-border dark:border-dark-border p-2"></div>
            <!-- Título query params -->
            <div class="flex flex-row items-center gap-4 pb-4">
              <lucide-icon [name]="Settings2" class="text-light-primary dark:text-dark-primary"></lucide-icon>
              <h2 class="!font-normal text-light-text-secondary dark:text-dark-text-secondary !mb-0 !pb-0">Query Params</h2>
            </div>
            <!-- Parámetros del chatbot -->
            <div cdkDropList (cdkDropListDropped)="dropParameter($event)" class="param-list">
              @for (param of conversationVisualizerParams.controls; track param; let i = $index) {
                <div class="param-item" cdkDrag>
                  <form [formGroup]="$any(param)" class="flex gap-2 pt-2">
                    <div class="drag-handle flex items-center cursor-move" cdkDragHandle>
                      <lucide-icon [name]="GripVertical" class="text-light-text-tertiary dark:text-dark-text-tertiary"></lucide-icon>
                    </div>
                    <div class="w-full md:w-3/4 flex gap-2">
                      <mat-form-field appearance="fill" class="flex-1">
                        <mat-label>Etiqueta</mat-label>
                        <input matInput formControlName="label" placeholder="Ej: ID de Conversación"
                          class="text-light-text dark:text-dark-text">
                      </mat-form-field>
                      <mat-form-field appearance="fill" class="flex-1">
                        <mat-label>Query Param</mat-label>
                        <input matInput formControlName="queryParam" placeholder="Ej: conversation_id"
                          class="text-light-text dark:text-dark-text">
                      </mat-form-field>
                      <mat-form-field appearance="fill" class="flex-1">
                        <mat-label>Tipo de Dato</mat-label>
                        <mat-select formControlName="dataType">
                          <mat-option value="string">Texto</mat-option>
                          <mat-option value="number">Número</mat-option>
                          <mat-option value="datetime">Fecha/Hora</mat-option>
                          <mat-option value="boolean">Booleano</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="icon-trash-wrapper flex items-center">
                      <button mat-icon-button color="warn" (click)="removeParameter(i)" >
                        <lucide-icon [name]="Trash2"></lucide-icon>
                      </button>
                    </div>
                  </form>
                </div>
              }
            </div>
            <!-- Button Agregar Parámetro -->
            <div class="pb-2">
              <button
                mat-button
                (click)="addParameter()"
                class="!bg-light-primary/10 dark:!bg-dark-primary/20 !text-light-primary dark:!text-dark-primary !rounded-xl !px-6 !py-5 ">
                Agregar Parámetro
              </button>
            </div>
          </form>
        }
      </mat-dialog-content>
    </mat-tab>
  </mat-tab-group>

  <div class="border-t border-light-border dark:border-dark-border mt-5 mb-5"></div>

  <mat-dialog-actions align="end" class="flex-shrink-0 bg-light-surface dark:bg-dark-surface gap-3 !pb-0">
    <button
      mat-button
      (click)="onCancel()"
      [disabled]="saving"
      class="modal-action-btn !text-light-text-secondary dark:!text-dark-text-secondary hover:!bg-light-bg-tertiary dark:hover:!bg-dark-surface-variant !rounded-xl !px-6 !py-5 transition-all duration-200">
      Cancelar
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="onSave()"
      [disabled]="!chatbotForm?.valid || saving"
      class="modal-action-btn !bg-light-primary dark:!bg-dark-primary !text-white hover:!bg-light-primary-variant dark:hover:!bg-dark-primary-variant !rounded-xl !px-6 !py-5 !shadow-soft hover:!shadow-medium transition-all duration-200">
      <div class="flex items-center justify-center gap-2">
        @if (!saving) {
          <span>{{ isEditMode ? 'Guardar cambios' : 'Crear Chatbot' }}</span>
        }
        @if (saving) {
          <span>{{ isEditMode ? 'Guardando...' : 'Creando...' }}</span>
        }
        @if (saving) {
          <mat-spinner diameter="20"></mat-spinner>
        }
      </div>
    </button>
  </mat-dialog-actions>
</div>

